module.exports = __webpack_public_path__ + "static/media/105.dbd7cab4.wav";